import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class GenetecForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
            {
                label: 'GUID',
                key: 'GUID',
                type: 'textfield',
            },
            {
                label: 'Application ID',
                key: 'applicationId',
                type: 'textfield',
            },
            {
                label: 'Host',
                key: 'host',
                type: 'textfield',
            },
            {
                label: 'Port',
                key: 'port',
                type: 'number',
            },
            {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            },
            {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            },
            {
                label: 'Use SSL',
                key: 'useSSL',
                type: 'checkbox',
            },
            {
                label: 'Base URI',
                key: 'baseURI',
                type: 'textfield',
            },
            {
                label: 'Entity Name',
                key: 'entityName',
                type: 'textfield',
            },
            {
                label: 'Entity Plural Name',
                key: 'entityPluralName',
                type: 'textfield',
            },
            {
                label: 'Report Type',
                key: 'reportType',
                type: 'textfield',
            },
        ];
    }
}
